//自定义指令
import { App } from 'vue'
import { getAssetsFile } from '@/utils/util'
interface IPictureBinding {
  value: string[]
  arg?: string
}
interface IImgBinding {
  value: string
  arg?: string
}

//图片懒加载加载
//因为要兼容webp的写法，针对picture标签的图片懒加载
//非超链接图片，使用了getAssetsFile读取资源，请使用getAssetsFile方法的链接规范
//用法： v-picture-lazy:距离多远就加载 默认 0 ,单位px
// <picture
//     v-picture-lazy:400="[
//       'https://img1.x7sy.com/shangminet/img/news/news_bg.webp',
//       'https://img1.x7sy.com/shangminet/img/news/news_bg.jpg',
//     ]"
//   >
//     <source />
//     <img />
// </picture>
const pictureLazy = {
  created(el: HTMLPictureElement, binding: IPictureBinding) {
    if (el.tagName !== 'PICTURE') return
    let value = binding.value
    let arg = binding.arg
    if (!arg || isNaN(Number(arg))) arg = '0'
    if (!value || !Array.isArray(value)) return
    let isLoad = false
    const childNodes = [...el.childNodes]
    function setUrl() {
      value.forEach((v, i) => {
        const child = childNodes[i] as HTMLImageElement | HTMLSourceElement
        if (!childNodes[i]) return
        let _v = v
        if (!_v.includes('http')) {
          _v = getAssetsFile(v)
        }
        if (!_v) return
        if (child.tagName === 'SOURCE') {
          child.srcset = _v
        }
        if (child.tagName === 'IMG') {
          child.src = _v
        }
      })
      isLoad = true
    }

    if (!IntersectionObserver) {
      setUrl()
      return
    }

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting && !isLoad) {
            setUrl()
          }
        })
      },
      { rootMargin: `0px 0px ${arg}px 0px` }
    )
    observer.observe(el)
  },
}
//img标签的图片懒加载
const lazy = {
  created(el: HTMLImageElement, binding: IImgBinding) {
    if (el.tagName !== 'IMG') return
    let value = binding.value
    let arg = binding.arg
    if (!value || typeof value !== 'string') return
    if (!arg || isNaN(Number(arg))) arg = '0'
    let isLoad = false
    function setUrl() {
      if (!value.includes('http')) {
        value = getAssetsFile(value)
      }
      el.src = value
      isLoad = true
    }
    if (!IntersectionObserver) {
      setUrl()
      return
    }
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting && !isLoad) {
            setUrl()
          }
        })
      },
      { rootMargin: `0px 0px ${arg}px  0px` }
    )
    observer.observe(el)
  },
}

export default function directive(app: App) {
  if (!app) return
  app.directive('picture-lazy', pictureLazy)
  app.directive('lazy', lazy)
}
